import { Box } from '@mui/joy'
import { ReactNode, useRef } from 'react'
import {
  FormProvider as ReactHookFormProvider,
  UseFormReturn,
} from 'react-hook-form'
import { FieldValues } from 'react-hook-form/dist/types'

type FormProviderProps<TFieldValues extends FieldValues = FieldValues> = {
  children: ReactNode
  form: UseFormReturn<TFieldValues>
  onSuccess?: (values: TFieldValues) => void
}

export function FormProvider<TFieldValues extends FieldValues = FieldValues>({
  children,
  form,
  onSuccess,
  ...props
}: FormProviderProps<TFieldValues>) {
  const { handleSubmit } = form
  const ref = useRef<HTMLElement>()

  return (
    <Box ref={ref} {...props}>
      <ReactHookFormProvider {...form}>
        <form
          style={{ margin: 0 }}
          {...(onSuccess ? { onSubmit: handleSubmit(onSuccess) } : {})}
        >
          {children}
        </form>
      </ReactHookFormProvider>
    </Box>
  )
}
